import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { Container, Row, Col, Card, Form, Button, Image, Offcanvas } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import auth from "../../actions/auth";
import { toast } from 'react-toastify';
import transaction from "../../actions/transaction";
import news from "../../actions/news";
import master from "../../actions/master";

const logo = require('./../../assets/images/logo-badge.png');
const waiting = require('./../../assets/images/regis-waiting.png');
const rejected = require('./../../assets/images/regis-rejected.png');

export default function Login() {
   const [passType, setPassType] = useState(true);
   const [show, setShow] = useState(false);
   const [resp, setResp] = useState('');
   const formRef = useRef();
   const navigate = useNavigate();
   const [form, setForm] = useState({
      email: '',
      password: ''
   });
   
   const handleClose = () => setShow(false);
   const handleShow = (err) => {
      setShow(true)
      setResp(err)
   };
   const handleClick = (urls) => {
      navigate(urls);
   };

   useEffect(() => {
      sessionStorage.setItem('token', '')
      sessionStorage.setItem('user_data', '')
      sessionStorage.setItem('profile', '')
   }, []);

   const handleSubmit = (e) => {
      e.preventDefault();
      let data = {
         type : "client",
         email : form.email,
         password : form.password
      }

      auth.actions.login(data).then((res) => {
         sessionStorage.setItem('token', res?.data?.token)
         sessionStorage.setItem('user_data', JSON.stringify( res?.data?.user))
         news.actions.setToken(res?.data?.token)
         transaction.actions.setToken(res?.data?.token)
         master.actions.setToken(res?.data?.token)
         auth.actions.setToken(res?.data?.token)

         if(res?.data?.token){
            formRef.current.reset();
            handleClick('/home');
         }
      }).catch((err) => {
         toast.error(err.message);
      });
   }

  return (
   <Container>
      <Row className="section mobile-bg align-items-end justify-content-center py-3">
         <Col sm={12} className="py-3">
            <Card className="card-login px-3">
               <Card.Body>
                  <div className="auth-logo">
                     <Image src={logo}/>
                  </div>
                  <h3 className="fw-bold text-center mt-5 mb-3">Selamat Datang</h3>
                  <div className="text-secondary text-center mb-5">Masukan Email/No.Handphone & Kata Sandi yang terdaftar</div>
                  <Form onSubmit={(e) => handleSubmit(e)} ref={formRef}>
                     <Form.Group className="mb-4" controlId="formBasicEmail">
                        <Form.Label className="mb-2">Email/No.Handphone</Form.Label>
                        <div className="position-relative">
                           <Form.Control type="text" placeholder="Enter/No. Handphone" onChange={(e) => setForm({...form, ...{email: e.target.value}})}/>
                           <Form.Text className="input-icon">
                              <i className="ph-envelope text-muted"></i>
                           </Form.Text>
                        </div>
                     </Form.Group>
                     <Form.Group className="mb-3" controlId="formBasicPassword">
                        <div className="d-flex align-items-center justify-content-between mb-2">
                           <Form.Label className="mb-0">Kata Sandi</Form.Label>
                           <u className="text-success-bold" onClick={() => handleClick('/forgot-password')}>Lupa kata sandi</u>
                        </div>
                        <div className="position-relative">
                           <Form.Control type={passType ? 'password' : 'text'} placeholder="Kata sandi" onChange={(e) => setForm({...form, ...{password: e.target.value}})}/>
                           <Form.Text className="input-icon" onClick={()=>setPassType(!passType)}>
                              {passType ?
                                 <i className="ph-eye text-success-bold fw-bold"></i> :
                                 <i className="ph-eye-slash text-success-bold fw-bold"></i>
                              }
                           </Form.Text>
                        </div>
                     </Form.Group>
                     <div className="d-grid gap-2 mt-5">
                        <Button className="btn-auth rounded-pill p-3" variant="success" type="submit" >
                           MASUK
                        </Button>
                        <div className="mt-2 mb-5">
                            <div className="text-center text-muted">
                                <span className="me-1">Belum punya akun?</span>
                                 <u className="text-success-bold" onClick={() => handleClick('/register')}>Daftar disini</u>
                            </div>
                        </div>
                     </div>
                  </Form>
               </Card.Body>
            </Card>

            <Offcanvas show={show} onHide={handleClose} placement="bottom" className="h-auto">
               <Offcanvas.Header closeButton>
                  <Offcanvas.Title></Offcanvas.Title>
               </Offcanvas.Header>
               <Offcanvas.Body className="py-5">
                     <div className="my-3 text-center">
                        {
                           resp.includes('dalam tahap proses verifikasi') ? 
                           <Image src={waiting}/> :
                           <Image src={rejected}/>
                        }
                     </div>
                     <div className="my-5">
                        {
                           resp.includes('dalam tahap proses verifikasi') ? 
                           <div className="text-center">
                              {resp}
                           </div> : 
                           <>
                              <div className="text-center">
                                 Ups, pengajuan/registrasi akunmu ditolak oleh petugas
                                 mitra,silahkan registrasi ulang atau hubungi mitra terkait!
                              </div>  
                              <div className="text-center text-danger my-1 fw-medium">
                                 Catatan verifikasi: Data yang didaftarkan tidak sesuai!
                              </div>
                           </>
                        }
                     </div>

                     <div className="d-grid gap-2 mt-4">
                        { resp.includes('dalam tahap proses verifikasi') ?
                           <Button className="btn-auth rounded-pill p-3" variant="success" onClick={() => handleClose()} >
                              OK, MENGERTI!
                           </Button> :
                           <>
                              <Button className="btn-auth rounded-pill p-3" variant="success" onClick={() => handleClose()} >
                                 REGISTRASI ULANG
                              </Button>
                              <Button className="btn-auth rounded-pill p-3 border" variant="light" onClick={() => handleClose()} >
                                 HUBUNGI MITRA
                              </Button>
                           </>
                        }
                     </div>
               </Offcanvas.Body>
            </Offcanvas>
         </Col>
      </Row>
   </Container>
  );
}